// extracted by mini-css-extract-plugin
module.exports = {"search-input":"SearchMobile_search-input__4Qz0a","search-icon":"SearchMobile_search-icon__R7SJg"};